import clsx from "clsx";
import * as React from "react";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
    toggleButtonGroup: {
        backgroundColor: theme.palette.admissionForm.toggleBackground,
        display: "inline-block",
        position: "relative",
        top: "0px",
        borderRadius: "5px",
        marginRight: "10px",
        height: "auto"
    },
    toggleButton: {
        display: "inline-block",
        textAlign: "center",
        margin: "4px 4px",
        backgroundColor: theme.palette.admissionForm.toggleBackgroundDarker,
        color: theme.palette.admissionForm.toggleTextColor,
        borderRadius: "4px",
        padding: "0px 12px",
        cursor: "pointer",
        lineHeight: "30px"
    },
    toggleButtonSelected: {
        color: theme.palette.admissionForm.selectedBtnText,
        backgroundColor: theme.palette.admissionForm.selectedBtnBg,
        fontWeight: 700,
    }
}))

export function ToggleRadioNamed(props) {
    const classes = useStyles();
    const [selectedItem, setSelectedItem] = React.useState(null);

    const handleClick = (itm) => {
        setSelectedItem(itm);
        if(props.onChange && (typeof props.onChange) == "function"){
            props.onChange(itm);
        }
    }

    React.useEffect(()=>{

        //   if(props.defaultItemSelected != null &&  props.defaultItemSelected.code != null){
        if(props.defaultItemSelected != null &&  props.defaultItemSelected.code != null){
            setSelectedItem(props.defaultItemSelected);
        }
    }, [props.defaultItemSelected]);

    return (
        <div className={classes.toggleButtonGroup} style={props.sx}>
            {
                props.items && props.items.map((item) => {
                    const classNameItem = selectedItem?.code == item.code ? clsx(classes.toggleButton, classes.toggleButtonSelected) : classes.toggleButton;
                    const btnWidthObj = { width: props.btnWidth ? props.btnWidth : "auto",
                                            pointerEvents: props.disabled? "none": "auto",
                                            color: props.disabled? "grey": ""};
                    return (
                        <div className={classNameItem} style={btnWidthObj} key={"toggleRadioNamed_item_" + item.code}
                             onClick={() => handleClick(item)}>
                            {item.description}
                        </div>
                    )
                })
            }
        </div>
    )
}